<template>
    <div id="app">
        <div id="overlay-wrapper">
            <div id="iframe-wrapper">
                <iframe width="100%" max-width="100%" height="100%"
                    :src="iFrameSrc"
                    frameborder="0"
                    id="src-iframe"
                >
                </iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'app',

    data() {
        return {
            overlayHtml: null,
            iFrameSrc: '',
        }
    },

    methods: {
        updateParams() {
            this.iFrameSrc = 'https://my.matterport.com/show/?m=djHLNBxFdXz&play=1'
            /* if(this.$route.query.src) {
                this.iFrameSrc = this.$route.query.src
            } */

            //?overlay=1&src=https://www.youtube.com/embed/5-xhpcgBMe4
            //?src=https://my.matterport.com/show/?m=JGPnGQ6hosj&play=0&hr=1&title=0&vr=0&hl=0
            //?src=https://my.matterport.com/show/?m=QFgBzW8YXf3&play=0&hr=1&title=0&vr=0&hl=0
            //src=https%3A%2F%2Fmy.matterport.com%2Fshow%2F%3Fm%3DQFgBzW8YXf3%26play%3D0%26hr%3D1%26title%3D0%26vr%3D0%26hl%3D0

            /* if(this.$route.query.overlay) {
                this.$store.dispatch('getOverlayData', this.$route.query.overlay).then((data) => {
                    if(!data) return;
                    console.log('dispatchData', data);

                    if(data.Css) {
                        let styleSheet = document.createElement("style");
                        styleSheet.type = "text/css";
                        styleSheet.innerText = atob(data.Css);
                        document.head.appendChild(styleSheet);
                    }

                    if(data.Html) {
                        this.overlayHtml = atob(data.Html);
                    }
        
                });
            } */
        }
    },

    created() {
        this.updateParams();
    }
}
</script>

<style>
    body {
        margin: 0;
        overflow: hidden;
    }

    #overlay {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width:100%;
        pointer-events: none;
    }

    #overlay-wrapper {
        height: 100vh;
    }

    #iframe-wrapper {
        /* width: 100%;
        height: 88vh !important; */
        height: 100%;
    }

    #iframe-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        width:100%;
    }

    #src-iframe {
        min-height: -webkit-fill-available;
        min-height: 100%;
    }

    #overlay-inner-wrapper > * {
        pointer-events: auto;
    }
</style>
